import { LuInfo, LuSparkles } from 'react-icons/lu';
import { commonHelpers } from 'utilities/helpers';
import { RangeData } from '../../../CU/CU-056-02/Models/Range';
import styles from '../styles.module.scss';

type PriceCardProps = {
    range: RangeData;
};

export const PriceCard = ({ range }: PriceCardProps) => {
    const minPrice = commonHelpers.formatMoney(Number(range.min));
    const maxPrice = commonHelpers.formatMoney(Number(range.max));

    return (
        <section className={styles.priceCard}>
            <div className={styles.celebIcon}>
                <LuSparkles />
            </div>

            <h2 className={styles.celebText}>物件の参考価格がわかりました！</h2>

            <span className={styles.priceLabel}>あなたの物件の参考価格</span>

            <div className={styles.priceRange}>
                <span className={styles.priceValue}>{minPrice}</span>
                <span className={styles.priceUnit}>万円</span>
                <span className={styles.priceDash}>〜</span>
                <span className={styles.priceValue}>{maxPrice}</span>
                <span className={styles.priceUnit}>万円</span>
            </div>

            <hr className={styles.priceDivider} />

            <div className={styles.noteRow}>
                <LuInfo className={styles.noteIcon} />
                <p className={styles.noteText}>
                    ※本価格はあくまで参考価格となり、実際の売却価格と異なることがあります。
                    <br />
                    より正確な金額を知りたい場合は「くわしく査定」をご利用ください。
                </p>
            </div>
        </section>
    );
};
